"use strict";

import BaseDashboard from "./base_dashboard";

class TimeTableDashboard extends BaseDashboard {

    constructor($rootScope, $http, $scope, $state) {
        super($rootScope, $http, $scope, $state);
        this.upcomingDays = [];
        this.upcomingHours = [];
    }

    applyNewData(data) {
        let days = [];
        let hours = [];
        let count = 0;

        for (let hour = 0; hour < 24; hour++) {
            hours.push({
                id: hour,
                hour: hour + ':00',
            });
        }

        let dataArray = [];

        if (data.days){
            dataArray = data.days
        } else  {
            dataArray = data
        }

        dataArray.forEach(function (item) {
            count++;
            let dayHours = {};

            function pushInHourItems(hour, current) {
                const prev = _.last(dayHours[hour].items) || null;
                if (prev) prev.next = current;

                current.next = null;
                current.prev = prev;

                dayHours[hour].items.push(current);
            }

            for (let hour = 0; hour < 24; hour++) {
                dayHours[hour] = {
                    id: hour,
                    items: [],
                };
            }

            for (const broadcast of item.broadcasts) {
                if (broadcast) {
                    const broadcastHour = new Date(broadcast.start).getHours();
                    for (const hour in dayHours) {
                        if (!dayHours.hasOwnProperty(hour)) continue;
                        if (broadcastHour === dayHours[hour].id) {
                            pushInHourItems(hour, {broadcast});
                            break;
                        }
                    }
                }

                for (const item of broadcast.children) {
                    if (item) {
                        const itemHour = new Date(item.start).getHours();
                        for (const hour in dayHours) {
                            if (!dayHours.hasOwnProperty(hour)) continue;
                            if (itemHour === dayHours[hour].id) {
                                pushInHourItems(hour, {item, broadcast});
                            }
                        }
                    }
                }

            }

            days.push({
                date: item.date,
                campaigns: item.campaigns,
                hours: dayHours,
            });
        });

        // console.log(days);
        this.upcomingHours = hours;
        this.upcomingDays = days;
    }

}

export default [() => {
    return {
        templateUrl: '/partial/app.partials.dashboard.time_table_dashboard',
        replace: true,
        controller: [
            '$rootScope',
            '$http',
            '$scope',
            '$state',
            TimeTableDashboard,
        ],
        controllerAs: 'ctrl',
        scope: {},
    };
}];
